import type { PresetPermissions } from './types';

export function parseInvitationPermissions(raw: unknown): Record<string, PresetPermissions> | null {
  if (raw == null || typeof raw !== 'object' || Array.isArray(raw)) return null;
  const result: Record<string, PresetPermissions> = {};
  for (const [module, value] of Object.entries(raw as Record<string, unknown>)) {
    if (value == null || typeof value !== 'object' || Array.isArray(value)) continue;
    const v = value as Record<string, unknown>;
    const actionsRaw = v.actions;
    let actions: Record<string, boolean> | undefined;
    if (actionsRaw && typeof actionsRaw === 'object' && !Array.isArray(actionsRaw)) {
      actions = {};
      for (const [k, val] of Object.entries(actionsRaw as Record<string, unknown>)) {
        if (val === true || val === 'true') actions[k] = true;
        else if (val === false || val === 'false') actions[k] = false;
      }
    }
    result[module] = {
      canView: typeof v.canView === 'boolean' ? v.canView : false,
      canEdit: typeof v.canEdit === 'boolean' ? v.canEdit : false,
      canVoid: typeof v.canVoid === 'boolean' ? v.canVoid : false,
      canDiscount: typeof v.canDiscount === 'boolean' ? v.canDiscount : false,
      canManageAgenda: typeof v.canManageAgenda === 'boolean' ? v.canManageAgenda : false,
      canViewOthers: typeof v.canViewOthers === 'boolean' ? v.canViewOthers : true,
      actions: actions ?? {},
    };
  }
  return Object.keys(result).length > 0 ? result : null;
}
